import { memo } from 'react';

import { AppStoreLinks } from './AppStoreLinks';

export * from './AppStoreLinks';

export default memo(AppStoreLinks);
